module.exports = " <div class=avatar :style=style> <span v-if=!src>{{ userInitial }}</span> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/Avatar.vue
 ** module id = 329
 ** module chunks = 2
 **/